import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.BUNDLE_SYNC}/${endpoint ? endpoint : ""}`

export const bundleSyncService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // reserveBundle: builder.query({
    //   query: (params) => ({
    //     url: buildBundleUrl("new_optim"),
    //     method: "GET",
    //     params: params,
    //   }),
    // }),
    getBundleSyncMeta: builder.query({
      query: () => ({
        url: buildBundleUrl("meta"),
        method: "GET",
      }),
    }),
    bundlesSync: builder.query({
      query: (params) => ({
        url: buildBundleUrl("sync"),
        method: "GET",
        params: params,
      }),
    }),

    importBundles: builder.mutation({
      query: ({ bundles, provider_id }) => ({
        url: buildBundleUrl("create"),
        method: "POST",
        body: {
          bundles,
          provider_id,
        },
      }),
    }),
  }),
})

export const { useGetBundleSyncMetaQuery, useLazyBundlesSyncQuery, useImportBundlesMutation } =
  bundleSyncService
